import { url } from "../../../../env";

export const getZipCode = async (zip) => {
    try {
        const response = await fetch(`${url}/getAddresByZipCode/${zip}`);
        if (!response.ok) {
            throw new Error('Error fetching zip code data');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching zip code:', error);
        return null;
    }
}